module.exports = __webpack_public_path__ + "img/ricardo3.793b2fed.gif";